//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const AUTO_SAVE_INTERVAL = 25;
const AUTO_SAVE_TIMEOUT = 2000;

export default {

	name: "latte-dashboard",

	data()
	{
		return {
			autoSaveWaited: 0,
			columns: 12,
			isChangeDetectorEnabled: false,
			isLoading: true,
			skipAutoSave: false,
			timeout: null,
			widgets: []
		};
	},

	mounted()
	{
		this.onTick();
		this.loadWidgets();

		Latte.action.dispatch("latte:dashboard:mounted", this);
		Latte.action.on("latte:tick", () => this.onTick());
	},

	methods: {

		setWidgetData(id, data)
		{
			const index = this.widgets.findIndex(w => w.id === id);

			if (index === -1)
				return;

			this.widgets[index].data = data;
			this.widgets[index].changed = true;
		},

		loadWidgets()
		{
			Latte.api.request("/api/latte/widgets", {cache: "no-cache"})
				.then(r => r.json())
				.then(r => this.onReceivedWidgets(r))
				.catch(err => Latte.core.handleError(err));
		},

		saveWidgets()
		{
			const widgetsToSave = this.widgets.filter(w => w.changed === true);

			if (widgetsToSave.length === 0)
				return;

			Latte.action.dispatch("latte:dashboard:save");

			const body = JSON.stringify(widgetsToSave.map(w => ({
				id: w.id,
				type: w.type,
				x: w.x,
				y: w.y,
				height: w.height,
				width: w.width,
				data: w.data
			})));

			Latte.api.request("/api/latte/widgets", {body, method: "POST"})
				.then(r => r.json())
				.then(r => this.onSavedWidgets(r))
				.catch(err => Latte.core.handleError(err));
		},

		onAutoSaveTick()
		{
			this.autoSaveWaited += AUTO_SAVE_INTERVAL;

			if (this.autoSaveWaited >= AUTO_SAVE_TIMEOUT)
			{
				Latte.action.dispatch("latte:dashboard:auto-save");
				this.saveWidgets();
				return;
			}

			Latte.action.dispatch("latte:dashboard:auto-save-tick", {timeout: AUTO_SAVE_TIMEOUT, waited: this.autoSaveWaited});
			this.timeout = Latte.core.timeout(AUTO_SAVE_INTERVAL, () => this.onAutoSaveTick());
		},

		onReceivedWidgets(response)
		{
			this.widgets = response.data.map(w => Object.assign(w, {changed: false}));
			this.isLoading = false;

			this.$nextTick(() => this.isChangeDetectorEnabled = this.widgets.length > 0);
		},

		onSavedWidgets(response)
		{
			Latte.action.dispatch("latte:dashboard:saved");

			if (response && response.error)
			{
				Latte.ui.snackbar.create({
					location: Latte.ui.snackbar.Locations.TOP,
					message: `${response.error}: ${response.error_description}`
				});

				return;
			}

			this.skipAutoSave = true;
			this.onReceivedWidgets(response);
		},

		onTick()
		{
			let columns = 12;

			if (window.innerWidth < 1600)
				columns = 8;

			if (window.innerWidth < 1400)
				columns = 6;

			if (window.innerWidth < 1000)
				columns = 4;

			if (window.innerWidth < 600)
				columns = 2;

			if (window.innerWidth < 400)
				columns = 1;

			this.columns = columns;
		},

		onWidgetMoved(id, x, y)
		{
			const index = this.widgets.findIndex(w => w.id === id);

			if (index === -1)
				return;

			this.widgets[index].x = x;
			this.widgets[index].y = y;
			this.widgets[index].changed = true;
		},

		onWidgetResized(id, h, w)
		{
			const index = this.widgets.findIndex(w => w.id === id);

			if (index === -1)
				return;

			this.widgets[index].height = h;
			this.widgets[index].width = w;
			this.widgets[index].changed = true;
		},

		onWidgetsChanged()
		{
			if (this.skipAutoSave)
				return this.skipAutoSave = false;

			Latte.action.dispatch("latte:dashboard:widgets-changed", this.widgets);

			clearTimeout(this.timeout);

			this.autoSaveWaited = -AUTO_SAVE_INTERVAL;
			this.onAutoSaveTick();
		}

	},

	watch: {

		widgets: {
			deep: true,
			handler()
			{
				if (!this.isChangeDetectorEnabled)
					return;

				this.onWidgetsChanged();
			}
		}

	}

}

